import { Auction, AuctionRequest, GetOntologyType } from "core/types";
import { Banner } from "ds/ui";
import { Divider, HorizontalLayout } from "ds_legacy/materials/layouts";
import { margin, padding } from "ds_legacy/materials/metrics";
import { Subheading } from "ds_legacy/materials/typography";
import { Locale as LocaleString } from "translations";
import Translations from "translations/types";
import { StaticPatientProfileTransferChips } from "./StaticPatientProfileTransferChips";

export function StaticChipInfo({
  auction,
  auctionRequest,
  getOntology,
  locale,
  requestAvailable = true,
  translations,
}: {
  auction: Auction;
  getOntology: GetOntologyType;
  locale: LocaleString;
  requestAvailable?: boolean | null;
  translations: Translations;
  auctionRequest: AuctionRequest;
}) {
  return (
    <>
      <HorizontalLayout
        flexWrap="wrap"
        margin={margin(0, 0, 0, 0)}
        padding={padding(1, 5)}
      >
        <div
          data-testid="overview-card-chip-info"
          style={{ margin: margin(0, 2, 0, 0), minWidth: "50%" }}
        >
          <HorizontalLayout aligned>
            <Subheading bold margin={margin(0, 0, 0, 0)}>
              {translations.auctionRequest.typeOfTransfer}
            </Subheading>
          </HorizontalLayout>

          <HorizontalLayout flexWrap="wrap">
            <div className="-ml-1 flex flex-wrap">
              <StaticPatientProfileTransferChips
                auction={auction}
                auctionRequest={auctionRequest}
                disabled={!requestAvailable}
                getOntology={getOntology}
                locale={locale}
                showServices={false}
                showSolutions
                showSpecializations
                translations={translations}
              />
            </div>
          </HorizontalLayout>
        </div>
      </HorizontalLayout>
      <Divider />
      <HorizontalLayout flexWrap="wrap" padding={padding(1, 5)}>
        <Subheading bold fullWidth margin={margin(0, 0, 0, 0)}>
          {translations.auctionRequest.mostImportantTransferDetails}
        </Subheading>
        {auction?.country_wide_search && (
          <div className="my-2 w-full">
            <Banner
              color="primary"
              message={translations.auctionRequest.germanyWideSearchWarning}
            />
          </div>
        )}

        <div className="-ml-1 flex flex-wrap">
          <StaticPatientProfileTransferChips
            auction={auction}
            auctionRequest={auctionRequest}
            disabled={!requestAvailable}
            getOntology={getOntology}
            locale={locale}
            showServices
            showSolutions={false}
            showSpecializations={false}
            translations={translations}
          />
        </div>
      </HorizontalLayout>
    </>
  );
}
